import type { UserScenario } from '@/types/taxExplorer';

const TYPES: UserScenario['incomeType'][] = ['employment', 'self-employed', 'investments', 'pension', 'mixed'];
export const INCOME_MIN = 10000;
export const INCOME_MAX = 1000000;
export const NET_WORTH_MAX = 10000000;

const clamp = (n: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, n));

export function scenarioToParams(s: Pick<UserScenario, 'grossIncome' | 'incomeType' | 'plannedDays' | 'netWorth'>): Record<string, string> {
  return { income: String(s.grossIncome), type: s.incomeType, days: String(s.plannedDays), worth: String(s.netWorth) };
}

export function paramsToScenario(params: URLSearchParams): Partial<UserScenario> {
  const out: Partial<UserScenario> = {};
  const income = Number(params.get('income'));
  if (params.get('income') && Number.isFinite(income)) out.grossIncome = clamp(Math.round(income), INCOME_MIN, INCOME_MAX);
  const type = params.get('type') as UserScenario['incomeType'] | null;
  if (type && TYPES.includes(type)) out.incomeType = type;
  const days = Number(params.get('days'));
  if (params.get('days') && Number.isInteger(days)) out.plannedDays = clamp(days, 0, 365);
  const worth = Number(params.get('worth'));
  if (params.get('worth') && Number.isFinite(worth)) out.netWorth = clamp(Math.round(worth), 0, NET_WORTH_MAX);
  return out;
}
